// 0xGG Team
// Distributed under AGPL3
//
// DESCRIPTION: Vega support
// Please include the following in your index.html file
//
//    <script src="https://cdn.jsdelivr.net/npm/vega-lite@4/build/vega-lite.min.js"></script>
//    <script src="https://cdn.jsdelivr.net/npm/vega-embed@6/build/vega-embed.min.js"></script>
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("codemirror"), require("yamljs"), require("../addon/fold"), require("../addon/fold-code")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","codemirror","yamljs","../addon/fold","../addon/fold-code"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldCodeWithVegaLite = this.HyperMD.FoldCodeWithVegaLite || {}), CodeMirror, YAML, HyperMD.Fold, HyperMD.FoldCode);
})(function (require, exports, CodeMirror, YAML, fold_1, fold_code_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.VegaLiteRenderer = void 0;
    CodeMirror = __importStar(CodeMirror);
    YAML = __importStar(YAML);
    var VegaLiteRenderer = function (code, info) {
        var id = "_vega-lite_id_" + Math.round(1e9 * Math.random()).toString(36);
        var el = document.createElement("div");
        el.id = id;
        var asyncRenderer = null;
        try {
            var spec = {};
            if (code.trim()[0] !== "{") {
                spec = YAML.parse(code);
            }
            else {
                spec = JSON.parse(code);
            }
            vegaEmbed("#" + id, spec);
        }
        catch (error) {
            el.innerText = error.toString();
        }
        return {
            element: el,
            asyncRenderer: null,
        };
    };
    exports.VegaLiteRenderer = VegaLiteRenderer;
    if (typeof vegaEmbed !== "undefined") {
        CodeMirror.defineOption("vega-lite", null, function (cm) {
            fold_code_1.getAddon(cm).clear("vega-lite");
            fold_1.getAddon(cm).startFold();
        });
        fold_code_1.registerRenderer({
            name: "vega-lite",
            pattern: /^vega\-lite$/i,
            renderer: exports.VegaLiteRenderer,
            suggested: true,
        });
        if (window["ECHOMD_DEBUG"]) {
            console.log("[HyperMD] PowerPack fold-code-with-vega-lite loaded.");
        }
    }
    else {
        if (window["ECHOMD_DEBUG"]) {
            console.log("[HyperMD] PowerPack fold-code-with-vega-lite failed to load.\nPlease include\n\n    <script src=\"https://cdn.jsdelivr.net/npm/vega-lite@4/build/vega-lite.min.js\"></script>\n    <script src=\"https://cdn.jsdelivr.net/npm/vega-embed@6/build/vega-embed.min.js\"></script>\n\nin your HTML file");
        }
    }
});
